export default "__VITE_ASSET__Dr_vo3b9__"